// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xJBO","delete":"styles_delete__2uHuk","update":"styles_update__3JicB","add":"styles_add__nbI-G"};